import { safeString } from "./safeString";
export class Tracker {
    constructor() {
        this.track = () => undefined;
        this.data = {};
    }
    static getInstance() {
        if (!this.instance) {
            this.instance = new Tracker();
        }
        return this.instance;
    }
    static configure(trackEvent) {
        if (!this.instance) {
            this.instance = new Tracker();
        }
        this.instance.track = trackEvent;
    }
    saveEventData(id, data) {
        this.data[id] = data;
        return this;
    }
    clearEventData(id) {
        delete this.data[id];
        return this;
    }
    trackEvent(eventName, data, storedDataId) {
        let trackedData = data;
        if (typeof this.data[safeString(storedDataId)] !== "undefined") {
            trackedData = Object.assign(Object.assign({}, this.data[safeString(storedDataId)]), data);
        }
        this.track(eventName, trackedData);
        return this;
    }
    trackAction(isTelemetryEnabled, eventName, data, storedDataId) {
        if (isTelemetryEnabled) {
            this.trackEvent(eventName, data, storedDataId);
        }
        return this;
    }
}
//# sourceMappingURL=Tracker.js.map